let digitsRE = /(\d{3})(?=\d)/g

export function convertCurrency(value, prefix = 'R$ ', decimals = 2) {
    // Garantir que o valor seja um número
    value = parseFloat(value);

    // Se não for um número válido, retornar zero formatado
    if (isNaN(value)) {
        value = 0;
    }

    // Formatar o valor com a precisão decimal especificada
    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });

    // Retornar o valor formatado com o prefixo (se especificado)
    return formattedValue;
}

// export function calcInterests(amount, tax, installments) {
//     var juros =
//         amount *
//         (tax / 100) *
//         (installments > 1 ? installments : installments - 1)
//     var montante = amount + juros

//     var result = {
//         amount_input: parseInt(amount),
//         tax_interest: tax,
//         amount_tax: parseInt(juros),
//         amount_final: parseInt(montante),
//         amount_installment: parseInt(montante / installments),
//     }


//     return result
// }

// NOVO BASEADO COMPETIDORES
// export function calcInterests(a, tax = 2.99, installments) {
//     var taxa_parcelamento = tax / 100;

//     var o = installments > 1 ? installments : 1
//     let installments_amount_juros = 0;

//     if (o > 1) {
//         installments_amount_juros = Number(
//             a / ((1 - Math.pow(1 + taxa_parcelamento, -o)) / taxa_parcelamento)
//         ).toFixed(2)
//     } else {
//         installments_amount_juros = a;
//     }

//     installments_amount_juros = parseFloat(installments_amount_juros);

//     var result = {
//         amount_input: parseInt(a),
//         tax_interest: tax * 100,
//         amount_tax: parseInt(installments * installments_amount_juros - a),
//         amount_final: parseInt(installments * installments_amount_juros),
//         amount_installment: parseInt(installments_amount_juros),
//     }

//     return result;
// }


export function calcInterests(a, tax = 0, installments, free_installments = 1) {

    if (installments > 1 && free_installments < installments) {
        var juros = (a * ((tax / 100) * installments));
    } else {
        var juros = 0;
    }

    var montante = a + juros;

    var result = {
        installments: installments,
        amount_input: parseInt(a),
        tax_interest: tax / 100,
        amount_tax: parseInt(juros),
        amount_final: parseInt(montante),
        amount_installment: parseInt(montante / installments),
    }

    return result;
}

export function clearString(string) {
    return removeSpaces(string.replace(/[^\w\s]/gi, ''));
}

export function removeSpaces(string) {
    return string.replace(/\s/g, '');
}

export function uniqid(prefix = "", random = false) {
    const sec = Date.now() * 1000 + Math.random() * 1000;
    const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
    return prefix + id + (random ? Math.trunc(Math.random() * 100000000) : "");
}

export function saveCustomerX(values) {
    let customer = {
        id: this.$store.getters['getLead'].id ?? null,
        id_lead: this.$store.getters['getLead'].id_lead ?? null,
        id_account: this.$store.getters['getLead'].id_account ?? null,
        id_store: this.$store.getters['getLead'].id_store ?? null,
        hash: this.$store.getters['getLead'].customer.hash ?? null,
        hash_store: this.$store.getters['getLead'].hash,
        identify: this.$store.getters['getLead'].identify,
        name: values.name,
        email: values.email,
        phone_number: clearString(values.phone_number ?? ''),
        document: clearString(
            this.$store.getters['session/getData'].payment.document ?? ''
        ),
        zip_code: clearString(values.zip_code),
        street_name: values.street_name,
        number: values.number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        city: values.city,
        state: values.state,
        src: this.$store.getters['session/getTracking'].src ?? "",
        last_contents: this.$store.getters['cart/getCart'] ?? null,
    }
    // this.$store.commit('setLead', customer)
}
